module.exports = __webpack_public_path__ + "img/bootstrap-icons.386691c2.svg";